import React from 'react';
import style from './initialising.module.scss';
import useApp from 'hooks/useApp';
import ClipLoader from 'components/ClipLoader';
import { DEFAULT_LANGUAGE } from 'translations';

interface Props {}

const Initialising: React.FC<Props> = props => {
    const { showSmartAgentBranding, appTextTranslations, language } = useApp();
    const chatLoading = appTextTranslations?.chatLoading?.[language];
    const poweredBy = appTextTranslations?.poweredBy?.[language] ?? appTextTranslations?.poweredBy?.[DEFAULT_LANGUAGE];

    const renderLoadingElement = (
        <>
            <p autoFocus={true}>{chatLoading}</p>
            <ClipLoader />

            {showSmartAgentBranding && (
                <div className={style.brandingWrapper}>
                    <svg
                        width="24"
                        height="27"
                        viewBox="0 0 24 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.2867 17.9505V13.5086C13.2867 13.2143 13.0491 12.9755 12.7573 12.9755C12.4655 12.9755 12.2279 13.2148 12.2279 13.5086V15.8122C12.2279 16.2128 11.9044 16.539 11.5067 16.539C11.1105 16.538 10.785 16.2104 10.7855 15.8122V15.7376L10.7708 15.4414C10.7708 15.1216 10.5156 14.8651 10.2029 14.8651C9.89008 14.8651 9.63585 15.1216 9.63585 15.4365V15.972H9.44409V15.4365C9.44409 15.0147 9.78468 14.6724 10.2029 14.6724C10.6215 14.6724 10.9621 15.0152 10.9621 15.4365L10.9768 15.8122C10.9768 16.1064 11.2149 16.3458 11.5067 16.3458C11.7985 16.3458 12.0361 16.1064 12.0361 15.8122V13.5086C12.0361 13.1079 12.3596 12.7827 12.7573 12.7827C13.155 12.7827 13.4785 13.1079 13.4785 13.5086V17.9505C13.4785 18.2447 13.7161 18.4836 14.0079 18.4836C14.2997 18.4836 14.5374 18.2447 14.5374 17.9505V12.0417C14.5374 11.641 14.8609 11.3149 15.2586 11.3149C15.6558 11.3149 15.9793 11.641 15.9793 12.0417V16.539C15.9793 16.8333 16.2169 17.0721 16.5087 17.0721C16.8005 17.0721 17.0381 16.8333 17.0381 16.5395L17.1079 15.3276V15.1594C17.1079 14.7587 17.4314 14.4331 17.8291 14.4331C18.2268 14.4331 18.5498 14.7587 18.5498 15.1589L18.544 16.2202C18.544 16.5331 18.7987 16.7896 19.1115 16.7896C19.4243 16.7896 19.679 16.5331 19.679 16.2182V15.6827H19.8707V16.2182C19.8702 16.6371 19.5282 16.9819 19.1115 16.9828C18.6948 16.9819 18.3527 16.6371 18.3522 16.2182L18.3581 15.1589C18.3581 14.8651 18.1209 14.6263 17.8291 14.6263C17.5368 14.6263 17.2992 14.8651 17.2992 15.1594V15.333L17.2299 16.5449C17.2285 16.9416 16.9035 17.2673 16.5087 17.2673C16.113 17.2673 15.7875 16.9397 15.7875 16.5424V12.0417C15.7875 11.7474 15.5504 11.5081 15.2586 11.5081C14.9663 11.5081 14.7291 11.7474 14.7291 12.0417V17.9505C14.7291 18.3512 14.4051 18.6768 14.0079 18.6768C13.6117 18.6763 13.2863 18.3487 13.2867 17.9505ZM9.97937 6.34674C7.95631 6.34674 6.30994 8.00441 6.30994 10.0417V19.0741C6.30994 21.1113 7.95631 22.7685 9.97937 22.7685H18.2541L22.6165 25.3281V10.0412C22.6165 8.00441 20.9706 6.34723 18.947 6.34723L9.97937 6.34674ZM23 26L18.1502 23.155H9.97937C7.74453 23.155 5.9269 21.3242 5.9269 19.0745V10.0412C5.9269 7.79107 7.74453 5.96077 9.97937 5.96077H18.947C21.1819 5.96077 22.9995 7.79107 22.9995 10.0412L23 26ZM5.15641 1C2.86497 1 1 2.87837 1 5.18539V23.3325L5.39161 20.6572C5.0676 20.0368 5.0515 19.332 5.0515 18.5836V9.55125C5.0515 7.08632 7.04334 5.08043 9.49142 5.08043H18.4591C19.1212 5.08043 19.7473 5.23149 20.3128 5.49436V5.18539C20.3133 2.87837 18.4483 1 16.1569 1H5.15641Z"
                            fill="#4B647F"
                            stroke="#4B647F"
                            stroke-width="0.3"
                        />
                    </svg>
                    <div className={style.brandingText}>
                        {poweredBy} <span className={style.boldText}>Smart</span>Agent
                    </div>
                </div>
            )}
        </>
    );

    return (
        <div className={style.initContainer}>
            <div className={style.loader}>{renderLoadingElement}</div>
        </div>
    );
};

export default Initialising;